import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CaixaService } from 'app/service/caixa/caixa.service';
import {MatTableDataSource, MatPaginator, MatSort} from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { SolicitacaoService } from 'app/service/solicitacao/solicitacao.service';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

@Component({
  selector: 'app-listar-numeros-caixas',
  templateUrl: './listar-numeros-caixas.component.html',
  styleUrls: ['./listar-numeros-caixas.component.scss']
})
export class ListarNumerosCaixasComponent implements OnInit {

  public areas: any[] = [];
  public subAreas: any[] = [];
  public responsaveis: any[] = [];
  public numerosGerados: any[] = [];
  public showSalvar = false;
  public loading = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSource = new MatTableDataSource<any[]>([]);
  displayedColumns: string[] = ['select', 'numero'];
  selection = new SelectionModel<any>(true, []);
  solicitacaoId;
  qtd;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef <ListarNumerosCaixasComponent>,
    private caixaService: CaixaService,
    private solicitacaoService: SolicitacaoService,
    private _snackBar: MatSnackBar
  ) { 
    console.log(this.data);
    this.solicitacaoId = this.data.solicitacaoId;
    this.listarNumeros(this.data.id);
    this.qtd = this.data.qtd;
  }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  listarNumeros(id: any) {
    this.caixaService.listNumeracaoCaixa(id).subscribe(data => {
      this.dataSource = new MatTableDataSource(data);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    }, error => {
      console.error(error);
    })
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  toggleAllRows(event) {
    if (event.checked) {
      // Selecionar apenas os itens visíveis na página atual
      const visibleRows = this.dataSource._pageData(this.dataSource._orderData(this.dataSource.data));
      this.selection.select(...visibleRows);
    } else {
      this.selection.clear();
    }
  }

  toggleRow(row) {
    this.selection.toggle(row);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.pageIndex = 0;
    }
  }

  selecionarNumeros() {
    let itensSelecionados = this.selection.selected as any[];
    console.log(itensSelecionados);
    let size = itensSelecionados.length;
    if (this.qtd == 2) {
      if (!this.isMultipleOf2(size)) {
        this.openSnackBarError('A quantidade de número deve formar pares.');
        return;
      }
    }
    if (this.qtd == 3) {
      if (!this.isMultipleOf3(size)) {
        this.openSnackBarError('A quantidade de número deve formar trios.');
        return;
      }
    }
    this.solicitacaoService.inserirNumerosSolicitacao(this.solicitacaoId, itensSelecionados).subscribe(data => {
      console.log(data);
      this.dialogRef.close(this.selection.selected);
    }, err => {
      console.error(err);
    });
  }

  salvarNumerosSelecionados() {
    this.solicitacaoService.inserirNumerosSolicitacao(this.solicitacaoId, this.selection.selected).subscribe(data => {
      console.log(data);
    }, err => {
      console.error(err);
    });
  }

  isMultipleOf2(num: number): boolean {
    if (num % 2 === 0) {
        return true;
    } else {
        return false;
    }
  }

  isMultipleOf3(num: number): boolean {
    if (num % 3 === 0) {
        return true;
    } else {
        return false;
    }
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/solicitacao/adicionar-solicitacao/listar-numeros/listar-numeros-caixas/listar-numeros-caixas.component.ts